<template>
    <div style="background:white; height:100%">   
        <section v-loading="loading"></section>  
        <div style=" display:flex; width:100%; background:#fff;line-height:30px;padding-top:3px; border-bottom:2px solid #389;">   
            <div style="width:1300px;display:flex; ">
                <div style="font-size:12px;line-height:30px;margin-right:4px">字段</div>
                <el-select v-model="selparam"  placeholder="请选择列名" clearable size="small" style="width:120px;margin-left:2px; ">
                    <span v-for="item in payCol" :key='item.key'>
                        <el-option :label="item.title" :value="item.key"></el-option>
                    </span>
                </el-select> 
                <el-input :placeholder="input_hold" v-model="txtparam" @keyup.enter.native="qryTabData" size="small" style="width:300px; height:30px; ">
                    <el-select v-model="oper" slot="prepend"   style="width:90px; " >
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                        </span>
                    </el-select>
                    <el-button size="small"  slot="append" icon="el-icon-search" @click="qryTabData" ></el-button>
                </el-input>
 
                <span style="color:#389;margin-left:10px;margin-right:5px;font-size:12px">状态</span>
                <el-select v-model="stfg_"  size="small" @change="stfgChange" style="width:130px;margin-bottom:3px;margin-left:2px; ">
                    <el-option label="所有订单" value="ALL" ></el-option>
                    <el-option label="已对账未收票" value="Y" ></el-option> 
                    <el-option label="已对账已收票" value="OK" ></el-option> 
                    <el-option label="未对账" value="N" ></el-option> 
                </el-select> 
                <el-button type="danger"   icon="iconfont icon-daochu" @click="expExcel" size="mini" style="margin-left:15px;height:30px;margin-top:1px">导出当前页面</el-button>
            </div>
        </div> 
        <el-table  :data="tabData" 
            border                            
            disabled-hover
            class="custom-table-border"
            :cell-style="{padding:'3px','font-size':'12px',color:'black'}"
            header-cell-class-name="clearPadding"
            style="overflow:auto;margin-top:1px;"
            size="small"
            :height="tabHeight" 
            :row-key="getRowKey"  
            ref="tabref" 
            @row-click="rowClick"
            v-loading="v_loading"
            element-loading-text="数据加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(100, 100, 100, 0.8)"
            highlight-current-row>
            <el-table-column label="序号" type="index" width="60" fixed>
                <el-table-column label="序号" type="index" width="60" fixed>
                    <template slot="header"  >
                        <el-link   @click="rowShow" style="font-size:12px;color:#404eff"> 
                            <el-tooltip content=" 清除条件" effect="light">
                                <i class="iconfont icon-shanchu1"  ></i>
                            </el-tooltip>
                        </el-link>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column  v-for="(item,index ) in payCol.filter(item=>item.thide=='N'&&item.key!=='SEL')" :key="index"
                :prop="item.key"
                :label="item.title"
                show-overflow-tooltip
                :align="item.align"                                  
                :sortable="item.sortable=='N'&&item.edcss!=='checkbox'"
                :min-width="item.width">
                <el-table-column  resizable :prop="item.key" :label="item.title" :align="item.align"  show-overflow-tooltip :min-width="item.width">
                    <template slot="header" slot-scope="scope"><span style="color:red" v-if="item.notnull=='Y'"> </span>
                        {{scope.row}}
                        <el-select v-if="item.key=='FCHK'" @change="qryTabData" v-model="v_row[item.key]" size="mini" placeholder="请选择" filterable clearable style="width:100%; " >
                            <el-option label="是" value="Y"  ></el-option>
                            <el-option label="否" value="N"  ></el-option>
                        </el-select>
                        <el-date-picker v-else-if="item.edcss=='date'" @change="qryTabData" size="mini"  type="date" :clearable="false" v-model="v_row[item.key]"  value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker> 
                        <el-input type="number" placeholder="数字框"  @keyup.enter.native="qryTabData" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-else-if="item.edcss=='number'" size="mini" v-model="v_row[item.key]" style="width:100%"> </el-input> 
                        <el-input :disabled="item.edcss=='image'" v-else @keyup.enter.native="qryTabData"  v-model="v_row[item.key]" size="mini" placeholder="请输入" ></el-input> 
                    </template>
                    <template  slot-scope="scope" >
                        <el-link v-if="item.key=='IDNO'" :underline="false" @click="repShow(scope.row)"><div style="color:#409eff;border-bottom:1px solid red;font-size:12px ">{{scope.row[item.key]}}</div> </el-link>
                        <el-link v-else-if="item.key=='FINVNO'" :underline="false" @click="repShow2(scope.row)"><div style="color:#409eff;border-bottom:1px solid red;font-size:11px ">{{scope.row[item.key]}}</div> </el-link>
                        <el-tag  v-else-if="item.key=='FCHK'&&scope.row['FCHK']=='Y'" size="mini" type="success" effect="dark"  >已对账</el-tag>
                        <el-tag  v-else-if="item.key=='FCHK'&&scope.row['FCHK']!=='Y'" size="mini" type="info" effect="dark">未对账</el-tag>  
                        <el-checkbox disabled v-else-if="item.edcss=='checkbox'" v-model="scope.row[item.key]" true-label="Y" false-label="N"></el-checkbox>
                        <el-link v-else-if="item.key=='FILEPATH'" :underline="false" @click="imgClick(scope.row[item.key])" > 
                            <div v-if="scope.row[item.key] && scope.row[item.key].lastIndexOf('.pdf')>-1 ">
                                <div @click="imgPreview(scope.row[item.key])" slot="error"><i class="iconfont icon-pdf"></i></div>
                            </div>
                            <el-image v-else style="width:100%;height:20px;" :src="scope.row[item.key]" :preview-src-list="[scope.row[item.key]]">                 
                                <div   slot="error" ><i class="el-icon-picture-outline"></i></div>
                            </el-image>
                        </el-link>
                        <div v-else v-text="scope.row[item.key]" style="float:left"> </div>
                    </template>
                </el-table-column>  
            </el-table-column>

            <el-table-column
                fixed="right"
                label="操作"
                align="center"
                width="80">
                <template slot-scope="scope">
                    <i class="iconfont icon-chenggong1" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                    <el-link   @click="editRec(scope.row, scope.$index )" :underline="false"  ><span style="font-size:12px;margin-right:5px;">确认</span></el-link>
                </template>
            </el-table-column>                                  
        </el-table> 
        <div style="margin-top:1px; overflow: hidden;display:flex;background:white;font-size:12px">
            <div style="float: left;padding-left:4px;font-size:12px;">
                <Page :total="dataCount" :page-size="rowSize" show-total :current="current" @on-change="changePage"></Page>
            </div>   
        </div> 
        <div class="one-div" style="margin-top:2px"><span class="oneRow"> 明细资料</span> </div>
        <el-table  :data="dtlData" 
            border                            
            size="small"
            ref="refdtl"
            class="custom-table-border"
            style="margin-top:-8px"
            show-summary
            :summary-method="getSummary"
            :cell-style="{padding:'2px'}"
            :height="265" 
            highlight-current-row> 
            <el-table-column label="序号" type="index" width="65" ></el-table-column>
            <el-table-column  v-for="(item,index ) in perCol.filter(item=>item.thide=='N')" :key="index"
                :prop="item.key"
                :label="item.title"
                show-overflow-tooltip
                :align="item.align"                                  
                :sortable="item.key!=='RN'&&item.edcss!=='checkbox'"
                :min-width="item.width">
                <template slot="header"><span style="color:red" v-if="item.notnull=='Y'">{{item.title}}</span></template>
            </el-table-column>               
        </el-table>
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="addWin" width="800px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:36px;height:36px;font-size:15px;padding-left:5px;"><i class="iconfont icon-xuanze" style="margin-right:5px"></i>{{$route.meta.title}} ：{{ $LANG('0109', '明细资料') }}</span>
            </div> 
 
                <span v-for="(gpitem,gpind) in formArr" :key="gpind"  >   
                    <div style="border-left:3px solid #409eff;line-height:30px;background:#ccc;margin-bottom:5px">
                        <span style="padding-left:5px;font-size:12px;font-weight:600"> {{gpitem.gpnm}} </span>
                    </div>        
                    <Form :model="mainRow" :label-width="120" ref="supForm"  label-position="right" inline  >  
                        <span v-for="(item,index) in gpitem.gplist" :key="index" >
                            <FormItem  :label="item.title" :class=" 'item-width'" :prop="item.FLDNO"  v-if="item.FHIDE==='N'">                  
                                <template slot="label"><span style="color:red" v-if="item.NOTNULL=='Y'">{{item.title}}</span></template>
                                <el-input-number :precision="item.DOTNUM" :disabled="saveFlag"  v-if="item.EDCSS==='number'" v-model="mainRow[item.FLDNO]" style="width:100%" ></el-input-number>   
                                <el-checkbox :disabled="item.DISABLED==='Y'?true:false " border v-else-if="item.EDCSS==='checkbox'" true-label="Y"  false-label="N" v-model="mainRow[item.FLDNO]" style="width:100%"></el-checkbox> 
 
                                <el-input :placeholder="item.HOLDER" type="text" v-else :disabled="item.DISABLED==='Y'?true:false "  v-model="mainRow[item.FLDNO]"></el-input>
                            </FormItem>
                        </span>
                    </Form>
                </span>
  
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                <span style="float:right">
                    <el-button type="info" @click="addWin=false" size="small"  icon="iconfont icon-shanchu">  取消</el-button>
                    <el-button type="primary" @click="saveRec" size="small" style="margin-left:30px" icon="iconfont icon-chenggong"> 确认</el-button>
                </span>
            </div>
        </el-dialog>
        <!-- 提示框 -->
        <el-dialog v-dialogDrag :visible.sync="promptWin"  width="450px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">提示</span>
            </div>
            <span>{{prompt}}</span>
            <span slot="footer"  >
                <el-button type="primary" size="small" @click="promptWin = false">确 定</el-button>
            </span>
        </el-dialog>
 
        <!-- report preview -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="repWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">报表预览</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <iframe :src="repUrl" frameborder="0" style="width: 100%; height: 100%"></iframe>
            </div>
        </el-dialog>
 
        <el-dialog v-dialogDrag :visible.sync="showViewer" width="1200px" append-to-body top="3vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">预览</span>
            </div>
            <div style="height:80vh;overflow-y:auto">
                <el-image fit="scale-down"  style=" margin:5px auto;height:800px;width:100% " :src="listurl"></el-image>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="loadWin" width="53px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
            <el-image  src="/assets/authorize/loading.gif" ></el-image>  
        </el-dialog>
    </div>  
</template>
<script>
 
import { getTabColOrData,getBaseData } from '../../api/user';
import { getDate } from '../../api/Select' 
//局部注册
export default {
    name:"po_queryList_gp",
    data () {
        return {
            repWin:false,
            repUrl:'',
            loadWin:false,
            addWin:false,
            payCol:[],
       
            dtlRow:{},
            operFlag:false,
            saveFlag:true,
            listurl:'',
            promptWin:false,
            prompt:'',
            showViewer:false,
            mainRow:{},
            input_hold:'请输入查询的值',
         
            listIndex:'-1',
            active:'', //二级菜单选中标志
            stfg_:'Y',
            menuBool:false,
            disabled:false, //新增权限制
            stfgSet:'ALL',
            idseq:'', //菜单主键
            lstseq:'',//菜单主键
            ruleValidate:{},
            formArr:[],
            tabData:[], //表数据
            allData:[],
            tabArr:[], //表列
            dtlData:[], //明细数据
            perCol:[],
            operArr:[],
            oper:'like',
            oper2:'like',
            comboArr:{},
            txtparam:'',
            selparam:'IDNO',
            v_row:{},
            delArr:[],
 
            rowIndex:'-1',
            v_url:'xuper_auth/getTableRecMany', //api请求路径
            v_formurl:'xuper_auth/getFormGroup', 
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') ,//api 请求密码
            v_admin:this.$cookies.get('v_admin') ,//api 请求密码
            v_usernm:this.$cookies.get('v_usernm'), //api 请求用户
            dataCount:0,
            rowSize:50,
            goPage:'',
            notNull:[],
            current:1,
            loading:false,
            v_loading:false,
            stfgBool:true,
            addBool:false, //新增,为true时--禁止
            editBool:false, //编辑,为true时--禁止
            delBool:false, //删除 ,为true时--禁止
            cfmBool:false, //审核 ,为true时--禁止
            cancelBool:false, //作废 ,为true时--禁止
            stfgArr:[],
            pageList: [ {
                value: 50,
                label: '50'
                }, {
                value: 100,
                label: '100'
            }],
            v_index:'',   
            v_idseq:'',  
        }
    },
    mounted () { 
        //用户表单新增、编辑、审核、作废权限 :frmid:  ID
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','16083','v_sys_user_priv',' and issel=\'Y\'').then(res=>{           
            if (this.v_admin==='N') { //表示有权限控制
                let row =res.result[0]
                if (row.ISADD==='N'){ //新增
                    this.addBool=true
                }if (row.ISUPD==='N'){ //修改
                    this.editBool=true
                }if (row.ISDEL==='N'){ //删除
                    this.delBool=true
                }if (row.ISCFM==='N'){ //审核
                    this.cfmBool=true
                }if (row.ISCANCEL==='N'){ //作废
                    this.cancelBool=true
                }
            }
        })  
        //操作符
        getBaseData('xuper_auth/getTableRecMany','PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        });
        //表单资料分组 
        getTabColOrData(this.v_formurl,'v_sys_form_fld','idseq','16083','gpnm,gpsort','','lstseq','1', ' order by gpsort').then((res) => {
            if (res.code==='200'){
                this.formArr = res.result             
            }else{
                this.promptWin=true
                this.prompt=res.result
            }
        })
 
    },
    computed: {
 
        tabHeight: function() {
            return (window.innerHeight - 485) + 'px';
        }, 
        tabWidth: function() {
            return (window.innerWidth - 140) + 'px';
        }, 
    },
    components: {
 
    },
    created () {       
        if (this.v_username){ 
            //查询数据
            this.qryTabData()
            this.getTabField() //表列字段
    
        }else{
            let routeUrl = this.$router.resolve({
                path: '/login',
                query: {},
            });
            window.open(routeUrl.href, '_self');
        }
    },
    watch: {
 
    },
    methods: {
        imgClick(path){
            console.log(path,path.lastIndexOf('.pdf'))
        },
        //表格页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.rowSize;
            var _end = index * this.rowSize
            this.current =index
            this.tabData = this.allData.slice(_start,_end);
        },
        initPage(){
            //产品明细
            this.dataCount =this.allData.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allData.length < this.rowSize){
                this.tabData = this.allData          
            }else{
                this.tabData =this.allData.slice(0,this.rowSize) //返回选定元素的子数组，不包含结尾元素
            }
        },
        rowShow(){
            Object.keys(this.v_row).forEach(item=>{
                this.v_row[item] =''
            })
            this.qryTabData()
        } ,
        //对指定列进行合计
        getSummary(param){
            const {columns ,data}=param
            const sums=[]
            columns.forEach((column,index)=>{
                if (index===0){
                    sums[index]='合计'
                    return
                }
                const values =data.map(item=>Number(item[column.property]));
                if( column.property==='AMT'){
                    sums[index]=values.reduce((prev,curr)=>{ //为数组中每一个元素依次执行回调函数
                        const value=Number(curr)
                        if(!isNaN(value)){
                            return Number(Number(prev) +Number(curr) ).toFixed(1)
                        }else{
                            return prev
                        }
                    },'')
                }
            })
            return sums
        },
        //图片预览
        imgPreview(path){
             let routeUrl = this.$router.resolve({
                path: '/fullPreview',
                query: {fileUrl:path},
            });
            window.open(routeUrl.href, '_blank');
        },
        repShow(row){
            this.repWin =true
            this.repUrl =this.$store.state.repUrl+ 'fin_stkchk.cpt'+'&p_corpid='+row['CORPID']+'&p_idno='+row['IDNO'] 
        },
        repShow2(row){
            this.repWin =true
            this.repUrl =this.$store.state.repUrl+ 'inv_stkchk.cpt'+'&p_corpid='+row['CORPID']+'&p_idno='+row['IDNO'] +'&p_invno='+row['FINVNO'] 
        },
        //导出
        expExcel(){
            this.loadWin =true   
            //导出
            this.$axios({
                method: 'post',
                url:'xuper_auth/report/GenExcel',
                data: {p_idseq:'397193',p_lstseq:'2064',p_json:JSON.stringify(this.allData),p_action:'采购对账'},
                responseType:'blob' //关键，声明响应类型为二进制流
            }).then(response=>{ 
                // 从响应头解析后端设置的文件名
                // 创建Blob对象并触发下载  创建下载链接
                const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob)
                link.download = '采购对账_'+getDate('full')+'.xls'
                link.click()
                URL.revokeObjectURL(link.href)
                this.loadWin =false
            }) 
 
        },
 
        //表行点击事件
        rowClick(row){
            this.getDtlData(row.IDSEQ)
  
        },
 
        saveRec(){
            let vm =this ,v_dttm=''
            let v_cond=''
            if (this.mainRow['FINV']=='Y'){
                v_dttm =getDate('full')
                v_cond =' set  rcvdttm=\''+v_dttm+'\',finv=\''+this.mainRow['FINV']+'\''
            } else{
                v_dttm=''
                v_cond =' set  rcvdttm=null,finv=\''+this.mainRow['FINV']+'\''
            }
            vm.$axios({
                method: 'post',
                url:'xuper_auth/updateRec',
                data: {p_key:'idseq',p_value:this.v_idseq, p_table:'ic_stk',p_cond:v_cond},
            }).then(res=>{ 
                this.tabData.splice(this.v_index,1,  Object.assign(this.mainRow ,{RCVDTTM:v_dttm}) ) 
 
                this.addWin =false
            })
        },
        //订单明细
        getOrdList(cond){
            let v_cond = ''
            // if (this.v_admin=='N' ){
            //     v_cond = ' and supno in (select idno from V_bs_sup where PHONENO=\''+this.v_username+'\')'
            // }
            this.v_loading =true
            //获取所有产品记录且初始化分页记录         
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'corpid',p_value:this.v_corpid,p_key2:'idty',p_value2:'POIN', p_cond:v_cond +cond+ ' order by '+this.selparam+' desc',p_table:'V_ic_STKchk'},
            }).then(res=>{ 
                if (res.code==='200'){
                    this.allData =res.result
                    this.$nextTick(() => { //有固定列时 查询后重新布局
                        this.$refs.tabref.doLayout()
                    })
                    this.v_loading =false
                    this.initPage()
                    if (this.tabData.length>0){
                        this.$refs.tabref.setCurrentRow(this.tabData[0])
                        this.getDtlData(this.tabData[0]['IDSEQ'])
                    }
                }else{
                    this.promptWin=true
                    this.prompt=res.result
                    this.v_loading =false
                }
                
            }) 
        },
        //查询明细数据
        getDtlData(idseq){
            this.dtlData=[]
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: { p_key:'idseq',p_value:idseq,p_table:'V_STKDTL'},
            }).then(res=>{ 
                this.dtlData =res.result  
                this.$nextTick(()=>{
                    this.$refs['refdtl'].doLayout()
                }) 
            })
        },
 
 
        getDtlKey(row){
            return row.IDSEQ+'-'+row.LSTSEQ
        },
        editRec(row, index){
            this.v_idseq =row['IDSEQ']
            this.v_index =index
            this.mainRow =JSON.parse(JSON.stringify(row))
            this.addWin=true   
                    
        },
        getRowKey(row){
            return row.IDSEQ+'-'+row.LSTSEQ
        },
        //查询
        qryTabData(){
            let cond_=''
            if (this.selparam){ //列1
                if (this.oper==='like'){
                    cond_=cond_+' and  '+this.selparam+'  like  \'%' + this.txtparam+'%\' '
                }else{
                    cond_=cond_+' and  '+this.selparam  +this.oper+' \''+this.txtparam+'\' '
                }
            }
 
            let v_cond ='' ,v_edcss=''
            Object.keys(this.v_row).forEach(item=>{
                if (this.v_row[item] ){
                    this.payCol.some(it=>{
                        if (it['key']== item){
                            v_edcss =it['edcss']
                        }
                    })
                    if (v_edcss =='number'){
                        v_cond =v_cond +' and '+item+'>='+  this.v_row[item] 
                    }else{
                        v_cond =v_cond +' and  '+item+' like \'%'+ (this.v_row[item]).trim()+'%\''
                    }

                }
            })
            if (this.stfg_=='ALL'){
                this.getOrdList( cond_ +v_cond)
            }else {
                if (this.stfg_=='Y'){
                    this.getOrdList( ' and fchk=\''+this.stfg_+'\''+ cond_+v_cond+' and rcvdttm is null')
                }if (this.stfg_=='OK'){
                    this.getOrdList( ' and fchk=\'Y\'' + cond_+v_cond+' and rcvdttm is not null')
                }else{
                    this.getOrdList( ' and fchk=\''+this.stfg_+'\''+ cond_+ v_cond)
                }
            }
        },
 
        //状态查询
        stfgChange(){
            this.qryTabData()
        },
 
        //获取表列字段
        getTabField(){
            let vm =this
 
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','397193','lstseq','2060','','',' order by sortby,itmseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.perCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                        notnull:res.result[k].NOTNULL,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','397193','lstseq','2062','','',' order by sortby,itmseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.payCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                        sortable:res.result[k].SORTABLE,
                        notnull:res.result[k].NOTNULL,
                    })
                }
            })
        }
    }
}
</script>
<style scoped lang="less">
    .el-aside {
        height: calc(100vh - 100px);// vh就是当前屏幕可见高度的1%   只用设置左侧 aside 高度
    }
    .oneMenu{
        line-height:35px;
        text-align:left;
        padding-left:35px;
        font-size:14px;
        color:white;
        background-color: #409eff;
    }
    .oneMenu:hover{
        cursor: pointer;
        color:#f4f6f8;
    }
    .twoMenu{
        display:flex;
        flex-direction:column;
        line-height:40px;
        background:white;
        padding-left:35px;
 
    }
    .twoMenu:hover{
        cursor: pointer;
        color:#409EFF;
    }
    .top{
        padding: 10px;
        background: rgba(0, 153, 229);
        color: #fff;
        text-align: center;
        font-size:10px;
        border-radius: 2px;
    }  
    .el-header  {
        background-color: #fff;
        color: #409EFF;
        text-align: center;
        line-height: 60px;
        width:100%;
    }
  .el-main {
    background-color: #fff;
    color: rgb(207, 206, 206);
    text-align: center;
    height:100%;
  }
 .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 1px auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
    .item-width  {
        width: 98%;
        color:#409EFF;
    }
    .active { 
        color:#D200D2; 
    } 
    .item-one{
        width: 96%;
    }
</style>
<style lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px !important;
            color:rgb(128,128, 128);
            font-size:12px;
        }
        td {
            padding: 5px ;
            font-size:11px;
        }   
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
 